import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6487596"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "risk-map-reports" }
const _hoisted_2 = { class: "risk-map-reports__creation" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Новый отчет ")
const _hoisted_4 = {
  key: 0,
  class: "risk-map-reports__creation-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        disabled: _ctx.isSubscriptionEnded,
        class: "risk-map-reports__creation-button",
        round: "",
        type: "primary",
        onClick: _ctx.handleOpenReportCreationPage
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      (!_ctx.reports.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " У пациента пока нет ни одного отчёта. Для создания отчета нажмите кнопку “Новый отчет” "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.reports.length)
      ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}